// src/app/modules/Dashboard/_redux/dashboard/Crud.js
import axios from "axios";
import config from "../../../../../config";

export const URL = config.URL;

// CREATE =>  POST: add a new data to the server
export function addNewData(type, data, queryId) {
  if (type === 'code') {
    return axios.post(`${config.URL}access-codes`, data);
  } else if (type === 'generate_group_codes') {
    return axios.post(`${config.URL}access-codes/group`, data);
  } else if (type === 'validate_code') {
    return axios.post(`${config.URL}access-codes/validate`, data);
  } else if (type === 'checkout_visitor') {
    return axios.post(`${config.URL}access-logs/${data.log_id}/checkout`);
  } else if (type === 'flag_visitor') {
    // NEW: Flag visitor
    return axios.post(`${config.URL}visitor-profiles/${data.profile_id}/flag`, { reason: data.reason });
  } else if (type === 'threat_alert') {
    // NEW: Create threat alert
    return axios.post(`${config.URL}visitor-profiles/${queryId}/threat-alert`, data);
  } else if (type === 'blacklist_visitor') {
    // NEW: Blacklist visitor
    return axios.post(`${config.URL}visitor-profiles/${queryId}/blacklist`, data);
  }  else if (type === 'add_member') {
    return axios.post(`${config.URL}members`, data);
  } else if (type === 'update_member') {
    return axios.patch(`${config.URL}members/${data.membership_id}`, data);
  } else if (type === 'update_member_details') {
    return axios.patch(`${config.URL}members/${queryId}/update-details`, data);
  } else if (type === 'suspend_member') {
    return axios.post(`${config.URL}members/${data.membership_id}/suspend`);
  } else if (type === 'reactivate_member') {
    return axios.post(`${config.URL}members/${data.membership_id}/reactivate`);
  } else if (type === 'delete_member') {
    // console.log(data);
    return axios.delete(`${config.URL}members/${data.membership_id}`);
  } else if (type === 'request_report') {
    return axios.post(`${config.URL}reports`, data);
  } else if (type === 'supervisor_visitor_checkin') {
    return axios.post(`${config.URL}operations/visitors/${queryId}/checkin`, data);
  }else if (type === 'visitor_checkin_from_code') {
    return axios.post(`${config.URL}operations/visitors/checkin-from-code`, data);
  } else if (type === 'invite_members') {
    return axios.post(`${config.URL}members/invite`, data);
  } else if (type === 'create_space') {
    return axios.post(`${config.URL}organizations/${queryId}/spaces`, data);
  } else if (type === 'create_space') {
    return axios.post(`${config.URL}organizations/${queryId}/spaces`, data);
  } else if (type === 'update_space') {
    return axios.patch(`${config.URL}organizations/${queryId}/spaces/${data.space_id}`, data);
  } else if (type === 'resend_invite') {
    return axios.post(`${config.URL}members/${data.membership_id}/resend`, {organization_id: data.organization_id});
  } else if (type === 'cancel_invite') {
    return axios.post(`${config.URL}members/${data.membership_id}/cancel`, {organization_id: data.organization_id});
  } else if (type === 'acknowledge_alert') {
    return axios.post(`${config.URL}threat-alerts/${data.alert_id}/acknowledge`, {organization_id: queryId});
  } else if (type === 'resolve_alert') {
    return axios.post(`${config.URL}threat-alerts/${data.alert_id}/resolve`, {
      status: data.status || 'resolved',
      action_taken: 'resolved',
      organization_id: queryId
    });
  } else if (type === 'force_clock_out') {
    // queryId = staff user_id
    return axios.post(`${config.URL}operations/staff/${queryId}/clockout`, data);
  } else if (type === 'integrations') {
    return axios.get(`${config.URL}integrations?organization_id=${queryId}`);
  } else if (type === 'integration_sync_logs') {
    //  queryParams = integration_id, paginationParams = { page, limit }
    return axios.get(
      `${config.URL}integrations/${queryId}/sync-logs`,
      // { params: paginationParams }
    );
  }

   else if (type === 'create_integration') {
    return axios.post(`${config.URL}integrations`, data);
  }

  else if (type === 'update_integration') {
    // orgId = integration_id
    return axios.patch(`${config.URL}integrations/${queryId}`, data);
  }
  else if (type === 'delete_integration') {
    return axios.delete(`${config.URL}integrations/${queryId}`);
  }
  else if (type === 'trigger_sync') {
    return axios.post(`${config.URL}integrations/${queryId}/sync`, data);
 
  } else if (type === 'get_oauth_url') {
    return axios.get(`${config.URL}integrations/oauth/connect`, { params: data });
  } else if (type === 'generate_scim_token') {
    // queryId = integration_id
    return axios.post(`${config.URL}integrations/${queryId}/scim-token`, data);
  } else if (type === 'oauth_callback') {
    return axios.get(`${config.URL}integrations/oauth/callback`, { params: data });
  } else if (type === 'scim_setup') {
    return axios.post(`${config.URL}integrations/scim-setup`, data);
  } else if (type === 'teams_setup') {
    return axios.post(`${config.URL}integrations/teams-setup`, data);
  } else if (type === 'calendar_setup_watch') {
    return axios.post(`${config.URL}integrations/${queryId}/calendar/setup-watch`, data);
  } else if (type === 'calendar_preview') {
    return axios.get(`${config.URL}integrations/${queryId}/calendar/preview`, { params: data });
  } else if (type === 'calendar_events') {
    return axios.get(`${config.URL}integrations/${queryId}/calendar/events`, { params: data });
  } else if (type === 'update_calendar_settings') {
    return axios.patch(`${config.URL}integrations/${queryId}`, { settings: { calendar: data } });
  }
  else if (type === 'supervisor_visitor_checkout') {
    // queryId = log_id
    return axios.post(`${config.URL}operations/visitors/${queryId}/checkout`, data);
  }
 
  else if (type === 'correct_shift') {
    return axios.post(`${config.URL}operations/shift/correct`, data);
  }
 
  else if (type === 'bulk_staff_action') {
    return axios.post(`${config.URL}operations/staff/bulk-action`, data);
  }
 
  else if (type === 'update_member_role') {
    // queryId = membership_id
    return axios.post(`${config.URL}operations/members/${queryId}/role`, data);
  }
 
  else if (type === 'toggle_supervisor') {
    // queryId = membership_id
    return axios.post(`${config.URL}operations/members/${queryId}/supervisor`, data);
  }
   

  else if (type === 'manager_clock_in') {

    return axios.post(`${config.URL}operations/staff/${queryId}/clockin`, data);

  }
 

  else if (type === 'assign_staff_spaces') {
    // queryId = membership_id
    return axios.post(`${config.URL}operations/members/${queryId}/spaces`, data);
  }
 
  else if (type === 'assign_resident_location') {
    // queryId = membership_id
    return axios.post(`${config.URL}operations/members/${queryId}/location`, data);
  } else if (type === 'add_to_blacklist') {
    return axios.post(`${config.URL}blacklist`, data);
  } else if (type === 'remove_from_blacklist') {
    return axios.delete(`${config.URL}blacklist/${data.blacklist_id}`);
  } else if (type === 'create_incident') {
    return axios.post(`${config.URL}incidents`, data);
  } else if (type === 'respond_to_incident') {
    return axios.post(`${config.URL}incidents/${data.incident_id}/respond`, data);
  } else if (type === 'add_incident_update') {
    return axios.post(`${config.URL}incidents/${data.incident_id}/updates`, {
      message: data.message,
      type: data.type
    });
  } else if (type === 'resolve_incident') {
    return axios.post(`${config.URL}incidents/${data.incident_id}/resolve`, data);
  } 
  
  else if (type === 'initialize_subscription') {
    return axios.post(`${config.URL}billing/organizations/${queryId}/subscription/initialize`, data);
  }
  else if (type === 'start_trial') {
    return axios.post(`${config.URL}billing/organizations/${queryId}/subscription/trial`, data);
  }
  else if (type === 'cancel_subscription') {
    return axios.delete(`${config.URL}billing/organizations/${queryId}/subscription`);
  }
  else if (type === 'pay_invoice') {
    return axios.post(`${config.URL}billing/organizations/${data.organization_id}/invoices/${data.invoice_id}/pay`);
  }
  else if (type === 'set_default_payment_method') {
    return axios.patch(`${config.URL}billing/organizations/${data.organization_id}/payment-methods/${data.payment_method_id}/default`);
  }
  else if (type === 'remove_payment_method') {
    return axios.delete(`${config.URL}billing/organizations/${data.organization_id}/payment-methods/${data.payment_method_id}`);
  }



  // ── Events mutations ──────────────────────────────────────────────────────
  else if (type === 'create_event') {
    return axios.post(`${config.URL}events`, data);
  }
  else if (type === 'update_event') {
    return axios.patch(`${config.URL}events/${queryId}`, data);
  }
  else if (type === 'publish_event') {
    return axios.post(`${config.URL}events/${queryId}/publish`);
  }
  else if (type === 'cancel_event') {
    return axios.post(`${config.URL}events/${queryId}/cancel`, data);
  }
  else if (type === 'delete_event') {
    return axios.delete(`${config.URL}events/${queryId}`);
  }

  // ── Wallet mutations ──────────────────────────────────────────────────────
  else if (type === 'request_payout') {
    return axios.post(`${config.URL}wallet/payout`, data);
  }
  else if (type === 'add_bank_account') {
    return axios.post(`${config.URL}wallet/bank-accounts`, data);
  }
  else if (type === 'remove_bank_account') {
    return axios.delete(`${config.URL}wallet/bank-accounts/${queryId}`);
  }
  else if (type === 'set_default_bank_account') {
    return axios.patch(`${config.URL}wallet/bank-accounts/${queryId}/default`);
  }

  else if (type === 'generate_report') {
    return axios.post(`${config.URL}security-analytics/generate`, data);
  } else if (type === 'export_report_pdf') {
    return axios.post(`${config.URL}security-analytics/${data.report_id}/export`, {
      format: 'pdf'
    });
  }
  return axios.post(URL, { data });
}

// READ
export function getAllDatas() {
  return axios.get(URL);
}

export function getSataById(dataId) {
  return axios.get(`${URL}/${dataId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findDatas(type, queryParams, paginationParams) {
  if (type === 'dashboard_data') {
    return axios.get(`${URL}partners/${queryParams}/dashboard-data`);
  } else if (type === 'users') {
    return axios.get(`${URL}partners/${queryParams}/users`);
  } else if (type === 'access_codes') {
    const params = new URLSearchParams();
    if (queryParams) params.append('organization_id', queryParams);
    if (paginationParams) {
      params.append('page', paginationParams.page || 1);
      params.append('limit', paginationParams.perPage || 10);
    }
    return axios.get(`${config.URL}access-codes?${params.toString()}`);
  } else if (type === 'report_list') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.report_type) params.append('type', paginationParams.report_type);
    if (paginationParams?.status) params.append('status', paginationParams.status);
    return axios.get(`${config.URL}reports?${params.toString()}`);
  } else if (type === 'access_logs') {
    const params = new URLSearchParams();
    if (queryParams) params.append('organization_id', queryParams);
    if (paginationParams) {
      params.append('page', paginationParams.page || 1);
      // params.append('search', paginationParams.search || '');
      params.append('limit', paginationParams.perPage || 10);
    }
    if (paginationParams.status) {
      params.append('status', paginationParams.status);
    }

    if (paginationParams.search) {
      params.append('search', paginationParams.search);
    }
    return axios.get(`${config.URL}access-logs?${params.toString()}`);
  } else if (type === 'access_code_stats') {
    return axios.get(`${config.URL}access-codes/stats?organization_id=${queryParams}`);
  } else if (type === 'spaces') {
    return axios.get(`${config.URL}organizations/${queryParams}/spaces`);
  } else if (type === 'security_analytics') {
    return axios.get(`${config.URL}security-analytics/latest?organization_id=${queryParams}`);
  } else if (type === 'threat_alerts') {
    const params = new URLSearchParams();
    if (queryParams) params.append('organization_id', queryParams);
    if (paginationParams) {
      params.append('page', paginationParams.page || 1);
      params.append('limit', paginationParams.perPage || 10);
    }
    return axios.get(`${config.URL}threat-alerts?${params.toString()}`);
  } else if (type === 'blacklist') {
    const params = new URLSearchParams();
    if (paginationParams.organization_id) params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.status) params.append('status', paginationParams.status);
    if (paginationParams.severity) params.append('severity', paginationParams.severity);
    if (paginationParams.reason) params.append('reason', paginationParams.reason);
    if (paginationParams.page) params.append('page', paginationParams.page);
    if (paginationParams.limit) params.append('limit', paginationParams.limit);
    return axios.get(`${config.URL}blacklist?${params.toString()}`);
  } else if (type === 'blacklist_stats') {
    return axios.get(`${config.URL}blacklist/network-stats?organization_id=${queryParams}`);
  } else if (type === 'incidents') {
    const params = new URLSearchParams();
    if (paginationParams.organization_id) params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.status) params.append('status', paginationParams.status);
    if (paginationParams.severity) params.append('severity', paginationParams.severity);
    if (paginationParams.type) params.append('type', paginationParams.type);
    if (paginationParams.page) params.append('page', paginationParams.page);
    if (paginationParams.limit) params.append('limit', paginationParams.limit);
    return axios.get(`${config.URL}incidents?${params.toString()}`);
  } else if (type === 'incident') {
    return axios.get(`${config.URL}incidents/${paginationParams?.incidentId}`);
  } else if (type === 'incident_stats') {
    return axios.get(`${config.URL}incidents/stats?organization_id=${queryParams}`);
  }  else if (type === 'live_overview') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.space_id)    params.append('space_id',    paginationParams.space_id);
    if (paginationParams?.location_id) params.append('location_id', paginationParams.location_id);
    if (paginationParams?.name)        params.append('name',        paginationParams.name);
    return axios.get(`${config.URL}operations/live-overview?${params.toString()}`);
  }
 
  else if (type === 'resident_live') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.space_id)    params.append('space_id',    paginationParams.space_id);
    if (paginationParams?.location_id) params.append('location_id', paginationParams.location_id);
    return axios.get(`${config.URL}operations/residents/live?${params.toString()}`);
  }
 
  else if (type === 'visitor_live') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.space_id) params.append('space_id', paginationParams.space_id);
    if (paginationParams?.status)   params.append('status',   paginationParams.status);
    if (paginationParams?.date)     params.append('date',     paginationParams.date);
    if (paginationParams?.name)        params.append('name',        paginationParams.name); 
    return axios.get(`${config.URL}operations/visitors/live?${params.toString()}`);
  }
 
  else if (type === 'mgmt_analytics') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.from_date)   params.append('from_date',   paginationParams.from_date);
    if (paginationParams?.to_date)     params.append('to_date',     paginationParams.to_date);
    if (paginationParams?.space_id)    params.append('space_id',    paginationParams.space_id);
    if (paginationParams?.location_id) params.append('location_id', paginationParams.location_id);
    return axios.get(`${config.URL}operations/mgmt-analytics?${params.toString()}`);
  }

  // NEW: Visitor Profiles
  else if (type === 'visitors') {
    const params = new URLSearchParams();
    if (paginationParams.organization_id) params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.search) params.append('search', paginationParams.search);
    if (paginationParams.risk_level) params.append('risk_level', paginationParams.risk_level);
    if (paginationParams.page) params.append('page', paginationParams.page);
    if (paginationParams.limit) params.append('limit', paginationParams.limit);
    return axios.get(`${config.URL}visitor-profiles?${params.toString()}`);
  } 
  // NEW: Visitor Profile Details
  else if (type === 'visitor_profile') {
    return axios.get(`${config.URL}visitor-profiles/${queryParams}`);
  }
  // NEW: Visitor Activity
  else if (type === 'visitor_activity') {
    const params = new URLSearchParams();
    if (paginationParams?.organization_id) params.append('organization_id', paginationParams.organization_id);
    return axios.get(`${config.URL}visitor-profiles/${queryParams}/activity?${params.toString()}`);
  }  else if (type === 'reports') {
    const params = new URLSearchParams();
    if (paginationParams.organization_id) params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.report_type) params.append('report_type', paginationParams.report_type);
    return axios.get(`${config.URL}security-analytics?${params.toString()}`);
  }
  // NEW: Visitor Statistics
  else if (type === 'visitor_stats') {
    return axios.get(`${config.URL}visitor-profiles/stats?organization_id=${queryParams}`);
  } else if (type === 'members') {
    const params = new URLSearchParams();
    if (paginationParams.organization_id) params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.search) params.append('search', paginationParams.search);
    if (paginationParams.role) params.append('role', paginationParams.role);
    if (paginationParams.status) params.append('status', paginationParams.status);
    if (paginationParams.page) params.append('page', paginationParams.page);
    if (paginationParams.limit) params.append('limit', paginationParams.limit);
    return axios.get(`${config.URL}members?${params.toString()}`);
  }
  // NEW: Member Details
  else if (type === 'member') {
    return axios.get(`${config.URL}members/${queryParams}`);
  } 
   else if (type === 'weekly_stats') {
    return axios.get(`${config.URL}operations/staff/monthly-stats`, {
      params:  queryParams
      // { organization_id: queryParams.organization_id, staff_id: queryParams.staff_id }
    });
  } else if (type === 'shift_history') {
    return axios.get(`${config.URL}operations/staff/shift-history`, {
      params: queryParams
      // { organization_id: queryParams.organization_id, staff_id: queryParams.staff_id }
    });
  }
  else if (type === 'intelligence_hotspots') {
    return axios.get(`${config.URL}intelligence/geo/hotspots?limit=20`);
  } else if (type === 'intelligence_heatmap') {
    const params = new URLSearchParams();
    if (paginationParams.grid_size) params.append('grid_size', paginationParams.grid_size);
    if (paginationParams.min_incidents) params.append('min_incidents', paginationParams.min_incidents);
    return axios.get(`${config.URL}intelligence/geo/heatmap?${params.toString()}`);
  } else if (type === 'intelligence_time') {
    return axios.get(`${config.URL}intelligence/analysis/time`);
  } else if (type === 'intelligence_location_risk') {
    const params = new URLSearchParams();
    params.append('longitude', paginationParams.longitude);
    params.append('latitude', paginationParams.latitude);
    if (paginationParams.radius_km) params.append('radius_km', paginationParams.radius_km);
    return axios.get(`${config.URL}intelligence/geo/location-risk?${params.toString()}`);
  }
  // NEW: Member Statistics
  else if (type === 'member_stats') {
    return axios.get(`${config.URL}members/stats?organization_id=${queryParams}`);
  }
  // NEW: High Risk Visitors
  else if (type === 'high_risk_visitors') {
    const params = new URLSearchParams();
    if (queryParams) params.append('organization_id', queryParams);
    if (paginationParams?.min_risk_score) params.append('min_risk_score', paginationParams.min_risk_score);
    if (paginationParams?.limit) params.append('limit', paginationParams.limit);
    return axios.get(`${config.URL}visitor-profiles/high-risk?${params.toString()}`);
  } else if (type === 'safety_score') {
    const params = new URLSearchParams();
    params.append('lat', paginationParams.lat);
    params.append('lng', paginationParams.lng);
    if (paginationParams.radius) params.append('radius', paginationParams.radius);
    return axios.get(`${config.URL}safety/score?${params.toString()}`);
  } 
  else if (type === 'time_analysis') {
    const params = new URLSearchParams();
    params.append('lat', paginationParams.lat);
    params.append('lng', paginationParams.lng);
    if (paginationParams.radius) params.append('radius', paginationParams.radius);
    return axios.get(`${config.URL}safety/time-analysis?${params.toString()}`);
  } 
  else if (type === 'nearby_incidents') {
    const params = new URLSearchParams();
    params.append('latitude', paginationParams.latitude);
    params.append('longitude', paginationParams.longitude);
    params.append('radius_km', paginationParams.radius_km || 5);
    if (paginationParams.limit) params.append('limit', paginationParams.limit);
    if (paginationParams.severity_min) params.append('severity_min', paginationParams.severity_min);
    return axios.get(`${config.URL}danger-zones/incidents?${params.toString()}`);
  } 
  else if (type === 'incident_patterns') {
    const params = new URLSearchParams();
    params.append('lat', paginationParams.lat);
    params.append('lng', paginationParams.lng);
    if (paginationParams.radius) params.append('radius', paginationParams.radius);
    return axios.get(`${config.URL}safety/patterns?${params.toString()}`);
  } 
  else if (type === 'risk_prediction') {
    const params = new URLSearchParams();
    params.append('lat', paginationParams.lat);
    params.append('lng', paginationParams.lng);
    if (paginationParams.radius) params.append('radius', paginationParams.radius);
    if (paginationParams.days) params.append('days', paginationParams.days);
    return axios.get(`${config.URL}safety/predict?${params.toString()}`);
  }


  else if (type === 'billing_plans') {
    // queryParams = org_type string (optional)
    const params = new URLSearchParams();
    if (queryParams) params.append('org_type', queryParams);
    return axios.get(`${config.URL}billing/plans?${params.toString()}`);
  }
  else if (type === 'subscription') {
    // queryParams = organization_id
    return axios.get(`${config.URL}billing/organizations/${queryParams}/subscription?type=${paginationParams}`);
  }
  else if (type === 'invoices') {
    // queryParams = organization_id, paginationParams = { status, page, limit }
    const params = new URLSearchParams();
    if (paginationParams?.status) params.append('status', paginationParams.status);
    if (paginationParams?.page)   params.append('page',   paginationParams.page);
    if (paginationParams?.limit)  params.append('limit',  paginationParams.limit);
    return axios.get(`${config.URL}billing/organizations/${queryParams}/invoices?${params.toString()}`);
  }
  else if (type === 'invoice') {
    // queryParams = invoice_id, paginationParams = { organization_id }
    return axios.get(`${config.URL}billing/organizations/${paginationParams.organization_id}/invoices/${queryParams}`);
  }
  else if (type === 'payment_methods') {
    // queryParams = organization_id
    return axios.get(`${config.URL}billing/organizations/${queryParams}/payment-methods`);
  }

  else if (type === 'staff') {
    const params = new URLSearchParams();
    if (paginationParams?.department) params.append('department', paginationParams.department);
    if (paginationParams?.status) params.append('status', paginationParams.status);
    return axios.get(`${config.URL}operations/staff/organization/${queryParams}?${params.toString()}`);
  }
  else if (type === 'active_staff') {
    return axios.get(`${config.URL}operations/staff/active/${queryParams}`);
  }
  else if (type === 'staff_attendance') {
    const params = new URLSearchParams();
    params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.staff_id) params.append('staff_id', paginationParams.staff_id);
    if (paginationParams.employee_id) params.append('employee_id', paginationParams.employee_id);
    if (paginationParams.department) params.append('department', paginationParams.department);
    if (paginationParams.from_date) params.append('from_date', paginationParams.from_date);
    if (paginationParams.to_date) params.append('to_date', paginationParams.to_date);
    return axios.get(`${config.URL}operations/staff/attendance?${params.toString()}`);
  }
  else if (type === 'staff_details') {
    return axios.get(`${config.URL}operations/staff/${queryParams}`);
  }

  // Resident Operations
  else if (type === 'residents') {
    const params = new URLSearchParams();
    if (paginationParams?.space_id) params.append('space_id', paginationParams.space_id);
    return axios.get(`${config.URL}operations/resident/organization/${queryParams}?${params.toString()}`);
  }
  else if (type === 'resident_details') {
    // Get resident by code_id
    return axios.get(`${config.URL}access-codes?code_id=${queryParams}&visitor_type=permanent_resident`);
  }
  else if (type === 'resident_by_unit') {
    const params = new URLSearchParams();
    params.append('organization_id', paginationParams.organization_id);
    return axios.get(`${config.URL}operations/resident/unit/${queryParams}?${params.toString()}`);
  }
  else if (type === 'resident_history') {
    const params = new URLSearchParams();
    params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.resident_user_id) params.append('resident_user_id', paginationParams.resident_user_id);
    if (paginationParams.unit_number) params.append('unit_number', paginationParams.unit_number);
    if (paginationParams.from_date) params.append('from_date', paginationParams.from_date);
    if (paginationParams.to_date) params.append('to_date', paginationParams.to_date);
    return axios.get(`${config.URL}operations/resident/history?${params.toString()}`);
  }

  // Unified Dashboard
  else if (type === 'unified_dashboard') {
    const params = new URLSearchParams();
    if (paginationParams?.from_date) params.append('from_date', paginationParams.from_date);
    if (paginationParams?.to_date) params.append('to_date', paginationParams.to_date);
    if (paginationParams?.space_id) params.append('space_id', paginationParams.space_id);
    return axios.get(`${config.URL}operations/dashboard/${queryParams}?${params.toString()}`);
  }
  else if (type === 'operations_logs') {
    const params = new URLSearchParams();
    params.append('organization_id', paginationParams.organization_id);
    if (paginationParams.log_type) params.append('log_type', paginationParams.log_type);
    if (paginationParams.status) params.append('status', paginationParams.status);
    if (paginationParams.from_date) params.append('from_date', paginationParams.from_date);
    if (paginationParams.to_date) params.append('to_date', paginationParams.to_date);
    if (paginationParams.space_id) params.append('space_id', paginationParams.space_id);
    if (paginationParams.search) params.append('search', paginationParams.search);
    if (paginationParams.page) params.append('page', paginationParams.page);
    if (paginationParams.limit) params.append('limit', paginationParams.limit);
    return axios.get(`${config.URL}operations/logs?${params.toString()}`);
  }
  else if (type === 'capacity_status') {
    return axios.get(`${config.URL}operations/capacity/${queryParams}`);
  }
  else if (type === 'operations_analytics') {
    const params = new URLSearchParams();
    if (paginationParams?.period) params.append('period', paginationParams.period);
    return axios.get(`${config.URL}operations/analytics/${queryParams}?${params.toString()}`);
  }
  else if (type === 'integrations') {
    return axios.get(`${config.URL}integrations?organization_id=${queryParams}`);
  }
  else if (type === 'integration_sync_logs') {
    return axios.get(`${config.URL}integrations/${queryParams}/sync-logs`);
  }
  else if (type === 'integration_groups') {
    // queryParams = integration_id
    return axios.get(`${config.URL}integrations/${queryParams}/groups`);
  }

  // ── Events ────────────────────────────────────────────────────────────────
  else if (type === 'events') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.status) params.append('status', paginationParams.status);
    if (paginationParams?.page)   params.append('page',   paginationParams.page);
    if (paginationParams?.limit)  params.append('limit',  paginationParams.limit);
    if (paginationParams?.search) params.append('search', paginationParams.search);
    return axios.get(`${config.URL}events?${params.toString()}`);
  }
  else if (type === 'event') {
    return axios.get(`${config.URL}events/${queryParams}`);
  }
  else if (type === 'event_orders') {
    const params = new URLSearchParams();
    params.append('organization_id', paginationParams.organization_id);
    if (paginationParams?.page)   params.append('page',   paginationParams.page);
    if (paginationParams?.limit)  params.append('limit',  paginationParams.limit);
    if (paginationParams?.status) params.append('status', paginationParams.status);
    return axios.get(`${config.URL}events/${queryParams}/orders?${params.toString()}`);
  }
  else if (type === 'all_orders') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.page)     params.append('page',       paginationParams.page);
    if (paginationParams?.limit)    params.append('limit',      paginationParams.limit);
    if (paginationParams?.status)   params.append('status',     paginationParams.status);
    if (paginationParams?.event_id) params.append('event_id',   paginationParams.event_id);
    return axios.get(`${config.URL}events/orders?${params.toString()}`);
  }
  else if (type === 'event_stats') {
    return axios.get(`${config.URL}events/stats?organization_id=${queryParams}`);
  }

  // ── Wallet ────────────────────────────────────────────────────────────────
  else if (type === 'wallet') {
    return axios.get(`${config.URL}wallet?organization_id=${queryParams}`);
  }
  else if (type === 'wallet_transactions') {
    const params = new URLSearchParams();
    params.append('organization_id', queryParams);
    if (paginationParams?.page)   params.append('page',   paginationParams.page);
    if (paginationParams?.limit)  params.append('limit',  paginationParams.limit);
    if (paginationParams?.type)   params.append('type',   paginationParams.type);
    return axios.get(`${config.URL}wallet/transactions?${params.toString()}`);
  }
  else if (type === 'bank_accounts') {
    return axios.get(`${config.URL}wallet/bank-accounts?organization_id=${queryParams}`);
  }
}

// UPDATE => PUT: update the data on the server
export function updateData(data) {
  return axios.put(`${URL}/${data.id}`, { data });
}

// UPDATE Status
export function updateStatusForDatas(ids, status) {
  return axios.post(`${URL}/updateStatusFordatas`, {
    ids,
    status
  });
}

// DELETE => delete the data from the server
export function deleteData(dataId) {
  return axios.delete(`${URL}/${dataId}`);
}

// DELETE datas by ids
export function deleteDatas(ids) {
  return axios.post(`${URL}/deletedatas`, { ids });
}

// Revoke access code
export function revokeAccessCode(codeId, reason) {
  return axios.post(`${config.URL}access-codes/${codeId}/revoke`, { reason });
}

// NEW: Generate security analytics report
export function generateSecurityReport(data) {
  return axios.post(`${config.URL}security-analytics/generate`, data);
}

// NEW: Get security analytics reports
export function getSecurityReports(queryParams) {
  const params = new URLSearchParams();
  if (queryParams.organization_id) params.append('organization_id', queryParams.organization_id);
  if (queryParams.report_type) params.append('report_type', queryParams.report_type);
  if (queryParams.page) params.append('page', queryParams.page);
  if (queryParams.limit) params.append('limit', queryParams.limit);
  return axios.get(`${config.URL}security-analytics?${params.toString()}`);
}

// NEW: Recalculate visitor risk
export function recalculateVisitorRisk(profileId) {
  return axios.post(`${config.URL}visitor-profiles/${profileId}/recalculate-risk`);
}

// NEW: Unflag visitor
export function unflagVisitor(profileId) {
  return axios.post(`${config.URL}visitor-profiles/${profileId}/unflag`);
}

// NEW: Export visitors
export function exportVisitors(organizationId) {
  return axios.get(`${config.URL}visitor-profiles/export?organization_id=${organizationId}`, {
    responseType: 'blob'
  });
}




export function staffCheckIn(data) {
  return axios.post(`${config.URL}operations/staff/check-in`, data);
}

export function staffCheckOut(data) {
  return axios.post(`${config.URL}operations/staff/check-out`, data);
}

export function staffStartBreak(data) {
  return axios.post(`${config.URL}operations/staff/break/start`, data);
}

export function staffEndBreak(data) {
  return axios.post(`${config.URL}operations/staff/break/end`, data);
}

// Resident Operations
export function residentAccess(data) {
  return axios.post(`${config.URL}operations/resident/access`, data);
}

export function addVehicleToResident(residentCodeId, data) {
  return axios.post(`${config.URL}operations/resident/${residentCodeId}/vehicles`, data);
}

export function addFamilyMemberToResident(residentCodeId, data) {
  return axios.post(`${config.URL}operations/resident/${residentCodeId}/family`, data);
}